import { useThree } from "@react-three/fiber";
import { useEffect } from "react";
import * as THREE from "three";
import { useSceneData } from "../../provider/SceneDataProvider";

/**
 * Component that can get added to the FloorPlanner Three scene.
 * Will listen for changes in the rotateSceneContents flag and rotate the camera accordingly to reflect the rotation for the user.
 *
 * @author Daniel Rösch, Rick Schierz
 * @date 07.10.2024
 */
const CanvasRotator = (): null => {
    const { rotateSceneContents, setRotateSceneContents } = useSceneData();
    const { camera } = useThree();

    useEffect(() => {
        if (rotateSceneContents === 0) return;

        // console.log(`Rotating camera by ${rotateSceneContents}°`);

        // Convert degrees to radians
        const radians = THREE.MathUtils.degToRad(rotateSceneContents);
        // console.log(`Radians ${radians}`);

        // Get current camera position
        const { x, y, z } = camera.position;

        // Rotate position around the Z-axis (assuming top-down view)
        const rotatedX = x * Math.cos(radians) - y * Math.sin(radians);
        const rotatedY = x * Math.sin(radians) + y * Math.cos(radians);

        // Set new camera position
        camera.position.set(rotatedX, rotatedY, z);
        
        // Ensure the camera keeps looking at the origin
        camera.lookAt(0, 0, 0);

        // Update projection matrix
        camera.updateProjectionMatrix();

        // Reset flag
        setRotateSceneContents(0);

    }, [rotateSceneContents, camera, setRotateSceneContents]);

    return null;
};

export default CanvasRotator;
